let roles_enums: any = [
  { label: "HOD Content", keyword: "hod-content", id: 2 },
  { label: "Product Manager", keyword: "product-manager", id: 4 },
  { label: "Accountant", keyword: "accountant", id: 5 },
  { label: "Admin", keyword: "admin", id: 6 },
];

export { roles_enums };
